
import Vue from "vue"

export default Vue.extend({
    props: ["data", "showActivity"],
    data() {
        return {
            activityCostData: { tableId: '', columns: [] } as { tableId: '', columns: { columnName: string; values: string[] }[] },
            search: "",
            actionFilter: "All",
            categoryFilter: "All",
        }
    },
    computed: {
        fields(): Array<any> {
            if (this.showActivity) {
                return [
                    { key: 'Name', label: 'Well' },
                    { key: 'Duration', label: !this.showActivity ? (this.data.datasets.length ? this.data.datasets[0].label : '') : '' + ' Time', class: 'text-center' },
                    { key: 'Activities', label: 'Activities', class: 'text-center' },
                ]
            }
            return [
                { key: 'Name', label: 'Well' },
                { key: 'Duration', label: !this.showActivity ? (this.data.datasets.length ? this.data.datasets[0].label : '') : '' + ' Time', class: 'text-center' },
            ]
        },
        computedTableData(): Array<any> {
            const arr = [] as any[]
            if (!this.data.datasets.length) return arr
            this.data.datasets.forEach((x:any, index:any) => {
                for (let i = 0; i < this.data.datasets[index].data.length; i++) {
                    if (this.data.datasets[index].data[i] != null) {
                        arr.push({
                            Name: this.data.labels[i],
                            Duration: this.data.datasets[index].data[i],
                            Activities: this.data.datasets[index].label
                        })
                    }
                }
            })

            return arr
        }
    },
    methods: {
    },
    mounted() {
    },
    watch: {
    }
})
